module.exports = __webpack_public_path__ + "static/indigo_logo-69246da96b36efa205f496119cada8ac.png";